module.exports = __webpack_public_path__ + "img/american_samoa.1a00ebf.webp";